module.exports = __webpack_public_path__ + "static/media/boca_periodontia.6d285937.svg";